var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashLeftIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.67529V4.92529",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.9253V22.1753",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.67529C17.25 8.18284 17.153 7.6952 16.9645 7.24023C16.7761 6.78526 16.4999 6.37186 16.1517 6.02364C15.8034 5.67542 15.39 5.3992 14.9351 5.21074C14.4801 5.02229 13.9925 4.92529 13.5 4.92529H10.125C9.13044 4.92529 8.17661 5.32038 7.47335 6.02364C6.77009 6.7269 6.375 7.68073 6.375 8.67529C6.375 9.66985 6.77009 10.6237 7.47335 11.3269C8.17661 12.0302 9.13044 12.4253 10.125 12.4253H14.25C15.2446 12.4253 16.1984 12.8204 16.9017 13.5236C17.6049 14.2269 18 15.1807 18 16.1753C18 17.1699 17.6049 18.1237 16.9017 18.8269C16.1984 19.5302 15.2446 19.9253 14.25 19.9253H9.75C8.75544 19.9253 7.80161 19.5302 7.09835 18.8269C6.39509 18.1237 6 17.1699 6 16.1753",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLeftIcon02);
export default __webpack_public_path__ + "static/media/dash-left-icon02.5158c989384ef855e8244fde64332bdc.svg";
export { ForwardRef as ReactComponent };